// @ts-nocheck
import {Routes} from '@angular/router';

export const NG_DOC_ROUTING: Routes = [
    {
        path: 'acium-docs-overview',
        loadChildren: () => import('./guides/acium-docs-overview/module')
    },
    {
        path: 'browser-activity',
        loadChildren: () => import('./guides/browser-activity/module')
    },
    {
        path: 'browser-extensions',
        loadChildren: () => import('./guides/browser-extensions/module')
    },
    {
        path: 'browser-settings',
        loadChildren: () => import('./guides/browser-settings/module')
    },
    {
        path: 'directory-integration',
        loadChildren: () => import('./guides/directory-integration/module')
    },
    {
        path: 'events',
        loadChildren: () => import('./guides/events/module')
    },
    {
        path: 'health-check',
        loadChildren: () => import('./guides/health-check/module')
    },
    {
        path: 'policy-assignment',
        loadChildren: () => import('./guides/policy-assignment/module')
    },
    {
        path: 'threat-protection',
        loadChildren: () => import('./guides/threat-protection/module')
    },
    {
        path: 'get-started',
        loadChildren: () => import('./guides/get-started/module')
    },
    {
        path: 'install',
        loadChildren: () => import('./guides/install/module')
    },
    {
        path: 'manage',
        loadChildren: () => import('./guides/manage/module')
    },
    {
        path: 'reference',
        loadChildren: () => import('./guides/reference/module')
    },
    {
        path: 'site-exceptions',
        loadChildren: () => import('./guides/site-exceptions/module')
    },
    {
        path: 'web-filtering',
        loadChildren: () => import('./guides/web-filtering/module')
    },
];
